import { CUSTOMER_ENDPOINTS } from "@/config/api"
import { httpClient } from "@/lib/http-client"
import type { Customer, CustomerUpdateRequest } from "@/types/customer"

export class CustomerApi {
  static getMe(): Promise<Customer> {
    return httpClient.get<Customer>(CUSTOMER_ENDPOINTS.ME)
  }

  static updateMe(data: CustomerUpdateRequest): Promise<Customer> {
    return httpClient.put<Customer, CustomerUpdateRequest>(CUSTOMER_ENDPOINTS.ME, data)
  }
}
